import { TypographyProps } from '@mui/material';
import { useBreakpoint, useTheme } from '../../../../hooks';
import { HeadlineLarge, DisplaySmall, DisplayMedium, BodyLarge } from '../../../../styles';
import { getBreakpointValue } from '../../../../types';

interface Props extends TypographyProps {
    headline: string;
    description?: string;
}

const LandingPageHeadline = ({ headline, description, ...props }: Props) => {
    const breakpoint = useBreakpoint();
    const { colors } = useTheme();

    const compactLayout = (
        <>
            <HeadlineLarge color={colors.onPrimaryDark} {...props}>
                {headline}
            </HeadlineLarge>
            {description && (
                <BodyLarge
                    mt={2}
                    mb={5}
                    maxWidth={getBreakpointValue(breakpoint, '100%', '95%', '90%')}
                >
                    {description}
                </BodyLarge>
            )}
        </>
    );

    const mediumLayout = (
        <>
            <DisplaySmall color={colors.onPrimaryDark} {...props}>
                {headline}
            </DisplaySmall>
            {description && (
                <BodyLarge mt={2} mb={5} maxWidth={'95%'}>
                    {description}
                </BodyLarge>
            )}
        </>
    );

    const expandedLayout = (
        <>
            <DisplayMedium color={colors.onPrimaryDark} {...props}>
                {headline}
            </DisplayMedium>
            {description && (
                <BodyLarge mt={2} mb={5} maxWidth={'90%'}>
                    {description}
                </BodyLarge>
            )}
        </>
    );
    const render = () =>
        getBreakpointValue(breakpoint, compactLayout, mediumLayout, expandedLayout);

    return render();
};

export { LandingPageHeadline };
